import React from "react";
import { Link } from "react-router-dom";

import "./ResultsButtons.css";
const ResultBtn = (props) => {
  return (
    <div className="result-buttons">
      <Link
        className="result-button"
        onClick={props.onClickFunction}
        to={props.link}
      >
        {props.btnText}
      </Link>
    </div>
  );
};

export default ResultBtn;
